// extracted by mini-css-extract-plugin
export var checkbox = "_8p-0";
export var circle = "_8p-3";
export var horizontalContainer = "_8p-7";
export var sm = "_8p-5";
export var switch0 = "_8p-2";
export var switchDisabled = "_8p-8";
export var switchEnabled = "_8p-1";
export var textSwitchContainer = "_8p-9";
export var textSwitchOption = "_8p-a";
export var textSwitchOptionSelected = "_8p-b";
export var verticalContainer = "_8p-6";
export var xs = "_8p-4";